module.exports = require('./helpers/bundle-url').getBundleURL('ekZ4q') + "default-icon.94aec26c.svg";